import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


const ORGANIZATION_CONFIG_FILE = 'config/organization.config.json';


@Injectable()
export class ConfigService {

  organizationConfig;


  constructor(private http:HttpClient) {
  }


  load() {

    return this.http.get(ORGANIZATION_CONFIG_FILE)
      .take(1)
      .do(data => {
        this.organizationConfig = data;
      })
      .toPromise();


  }
}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/services/config.service.ts